<app-panel>
  <div class="relative size-full min-h-0 overflow-hidden rounded-2xl bg-surface-50 ring-2 ring-surface-100 py-3">

    @if (orchestrator.isLoading()) {
      <app-loading></app-loading>
    }

    <div
      class="size-full grid grid-cols-8 px-3 gap-3 grid-rows-[150px_150px_150px_200px_200px_200px] min-h-0 overflow-x-hidden overflow-y-auto">
      <div class="col-span-4 row-span-1">
        @if (orchestrator.vehicle$ | async; as vehicle) {
          <p-card class="size-full">
            <ng-template #header>
              <div class="size-full inline-flex items-center gap-2 px-4 py-2">
              <span class="font-semibold text-surface-500 text-3xl">
                {{ vehicle.displayName }}
              </span>
                <p-tag
                  rounded
                  size="small"
                  icon="pi pi-circle-on"
                  [value]="vehicle.statusLabel"
                  [ngClass]="vehicle.statusColor">
                </p-tag>
              </div>
            </ng-template>
            <ng-template #content>
              <p-carousel [value]="details" [numVisible]="3" [numScroll]="1" circular [autoplayInterval]="3000">
                <ng-template pTemplate="item" let-item>
                  <div class="size-full p-1 gap-1">
                    <div class="size-full inline-flex items-center gap-2">
                      <div
                        class="min-h-12 min-w-12 rounded-[25%] flex items-center justify-center text-2xl text-primary-500 bg-primary-400/25">
                        <ng-icon [name]="item.icon"></ng-icon>
                      </div>
                      <div class="flex flex-col items-start justify-between min-w-0 w-full">
                        <span class="w-full text-sm text-surface-400 truncate">{{ item.label }}</span>
                        <span [pTooltip]="item.value" tooltipPosition="top"
                              class="w-full text-[1.25rem] text-surface-500 font-semibold truncate">{{ item.value }}</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-carousel>
            </ng-template>
          </p-card>
        } @else {
          <p-card class="size-full component">
            <p-skeleton></p-skeleton>
          </p-card>
        }
      </div>

      <div class="col-span-4 row-span-2 row-start-2">
        <p-card class="size-full overflow-hidden">
          <ng-template pTemplate="header">
            <div class="p-2 inline-flex items-center gap-2 w-full h-auto border-b-1 border-surface-200">
              <span class="ml-1 text-xl font-semibold text-surface-500">Historia statusów</span>
              <p-badge [value]="statusHistory.length"/>
            </div>
          </ng-template>

          <ng-template pTemplate="content">
            <div class="size-full pr-2 py-2">
              <div class="size-full overflow-x-hidden overflow-y-auto min-h-0">
                <p-timeline [value]="statusHistory" align="left" class="p-5">
                  <ng-template #marker let-event>
              <span
                class="flex items-center justify-center rounded-full bg-primary-500/25 w-12 h-12 text-primary-500 text-3xl">
                <ng-icon [name]="event.icon"></ng-icon>
              </span>
                  </ng-template>
                  <ng-template #content let-event>
                    <div class="h-12 w-full flex flex-col justify-center text-surface-500">
                      <span class="text-center font-semibold">{{ event.status }}</span>
                      <span class="text-sm text-surface-500">
                  {{ event.date.toFormat('dd.MM.yyyy HH:mm') }}
                </span>
                    </div>
                  </ng-template>
                </p-timeline>

                @if (statusHistory.length === 0) {
                  <p class="text-surface-500 text-center py-4">Brak historii</p>
                }
              </div>
            </div>
          </ng-template>
        </p-card>
      </div>

      <!--          TODO: map feature is obsolete by the moment-->
      <!--      <div class="col-span-4 row-span-3 component flex flex-col items-start justify-start">-->
      <!--        <div class="p-2 inline-flex items-center w-full h-auto">-->
      <!--        <span class="text-md text-surface-800">-->
      <!--          Lokalizacja pojazdu-->
      <!--        </span>-->
      <!--        </div>-->
      <!--        <div class="size-full overflow-hidden">-->
      <!--          @if (iframeUrl(); as url) {-->
      <!--            <iframe-->
      <!--              class="size-full rounded-t-2xl"-->
      <!--              [src]="url"-->
      <!--              loading="lazy"-->
      <!--              referrerpolicy="no-referrer-when-downgrade"-->
      <!--              title="parking-hub-map">-->
      <!--            </iframe>-->
      <!--          } @else {-->
      <!--            <p-skeleton-->
      <!--              width="100%"-->
      <!--              height="100%"-->
      <!--              class="rounded-t-2xl">-->
      <!--            </p-skeleton>-->
      <!--          }-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="col-span-4 row-span-3 component flex flex-col items-start justify-start">
        <div class="size-full overflow-hidden relative">
          <p-galleria
            [value]="images"
            [(visible)]="fullscreenMode"
            [fullScreen]="fullscreenMode"
            [showIndicators]="fullscreenMode"
            [showThumbnails]="fullscreenMode"
            [showThumbnailNavigators]="fullscreenMode"
            [containerClass]="'size-full'"
            [showItemNavigators]="true"
            [class.rounding]="!fullscreenMode"
            [ngClass]="fullscreenMode ? 'p-galleria-fullscreen' : ''">
            <ng-template #item let-item>
              <div class="size-full">
                <img [src]="item.itemImageSrc" class="size-full object-cover" [alt]="item.alt">
              </div>
            </ng-template>
          </p-galleria>
          <div class="absolute top-2 left-2">
            <p-button
              rounded
              (onClick)="toggleGalleriaFullscreen()"
              icon="pi pi-window-maximize">
            </p-button>
          </div>
        </div>
      </div>

      <div class="col-span-8 row-span-3 min-h-0">
        <p-tabs value="0" scrollable class="size-full component flex flex-col min-h-0">
          <p-tablist>
            <p-tab value="0" class="flex items-center !gap-2">
              <span class="font-bold whitespace-nowrap">Specyfikacja</span>
            </p-tab>
            <p-tab value="1" class="flex items-center !gap-2">
              <span class="font-bold whitespace-nowrap">Identyfikacja</span>
            </p-tab>
            <p-tab value="2" class="flex items-center !gap-2">
              <span class="font-bold whitespace-nowrap">Ubezpieczenie</span>
            </p-tab>
            <p-tab value="3" class="flex items-center !gap-2">
              <span class="font-bold whitespace-nowrap">Dokumentacja</span>
            </p-tab>
            <p-tab value="4" class="flex items-center !gap-2">
              <span class="font-bold whitespace-nowrap">Serwis</span>
            </p-tab>
            <p-tab value="5" class="flex items-center !gap-2">
              <span class="font-bold whitespace-nowrap">Notatnik</span>
            </p-tab>
            <p-tab value="6" class="flex items-center !gap-2">
              <span class="font-bold whitespace-nowrap">Zdjęcia</span>
            </p-tab>
          </p-tablist>
          <p-tabpanels class="flex-1 min-h-0">
            <p-tabpanel value="0">
              <div class="px-4 py-2">
                <p-message [severity]="tabBannerType" [icon]="tabBannerIcon">
                  Dane dotyczące specyfikacji technicznej pojazdu
                </p-message>
              </div>
              @if (orchestrator.vehicle$ | async; as vehicle) {
                <h3 class="mt-4 px-4 py-2 w-full font-semibold text-lg">Dane katalogowe</h3>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Marka
                  </h4>
                  <p>
                    {{ vehicle.displayBrand }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Model
                  </h4>
                  <p>
                    {{ vehicle.displayModel }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Kategoria
                  </h4>
                  <p>
                    {{ vehicle.categoryName }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Numer fabryczny
                  </h4>
                  <p>
                    {{ vehicle.displayFactoryNumber }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Przebieg
                  </h4>
                  <p>
                    @if (vehicle.hasMileage) {
                      {{ vehicle.mileage }} km
                    } @else {
                      {{ vehicle.motoHours }} M/H
                    }
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Właściciel
                  </h4>
                  <p>
                    {{ vehicle.owner.name }}
                  </p>
                </div>
                <p-divider/>
              }
            </p-tabpanel>
            <p-tabpanel value="1">
              <div class="px-4 py-2">
                <p-message [severity]="tabBannerType" [icon]="tabBannerIcon">
                  Dane dotyczące identyfikacji pojazdu
                </p-message>
              </div>
              @if (orchestrator.vehicle$ | async; as vehicle) {
                <h3 class="mt-4 px-4 py-2 w-full font-semibold text-lg">Dane identyfikacjne</h3>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Numer rejestracyjny
                  </h4>
                  <p>
                    {{ vehicle.plateNumber }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    VIN
                  </h4>
                  <p>
                    {{ vehicle.vin }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Seria i numer dowodu rejestracyjnego
                  </h4>
                  <p>
                    {{ vehicle.registrationCard }}
                  </p>
                </div>
                <p-divider/>
              }
            </p-tabpanel>
            <p-tabpanel value="2">
              @if (orchestrator.vehicle$ | async; as vehicle) {
                @if (vehicle.hasInsurance) {
                  <div class="px-4 py-2">
                    <p-message [severity]="tabBannerType" [icon]="tabBannerIcon">
                      Dane dotyczące ubezpieczenia pojazdu
                    </p-message>
                  </div>
                  <h3 class="mt-4 px-4 py-2 w-full font-semibold text-lg">Polisa ubezpieczeniowa</h3>
                  <p-divider/>
                  <div class="inline-flex items-center justify-between w-full px-4 text-base">
                    <h4>
                      Data ważności
                    </h4>
                    <p>
                      {{ vehicle.insuranceExpiryDate }}
                    </p>
                  </div>
                  <p-divider/>
                } @else {
                  brak danych
                }
              }
            </p-tabpanel>
            <p-tabpanel value="3">
              <div class="px-4 py-2">
                <p-message [severity]="tabBannerType" [icon]="tabBannerIcon">
                  Dokumentacja i ewidencja pojazdu w magazynie
                </p-message>
              </div>
              @if (orchestrator.vehicle$ | async; as vehicle) {
                <h3 class="mt-4 px-4 py-2 w-full font-semibold text-lg">Ewidencja i dokumentacja</h3>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Numer kluczyka
                  </h4>
                  <p>
                    {{ vehicle.keyNumber || vehicle.noData }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Numer dokumentów
                  </h4>
                  <p>
                    {{ vehicle.documentNumber }}
                  </p>
                </div>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Numer archiwalny
                  </h4>
                  <p>
                    {{ vehicle.archiveNumber || vehicle.noData }}
                  </p>
                </div>
                <p-divider/>
              }
            </p-tabpanel>
            <p-tabpanel value="4">
              <div class="px-4 py-2">
                <p-message [severity]="tabBannerType" [icon]="tabBannerIcon">
                  Dane serwisowe pojazdu
                </p-message>
              </div>
              @if (orchestrator.vehicle$ | async; as vehicle) {
                <h3 class="mt-4 px-4 py-2 w-full font-semibold text-lg">Dane serwisowe</h3>
                <p-divider/>
                <div class="inline-flex items-center justify-between w-full px-4 text-base">
                  <h4>
                    Data ważności przeglądu technicznego
                  </h4>
                  <p>
                    {{ vehicle.technicalInspectionDate }}
                  </p>
                </div>
                <p-divider/>
              }
            </p-tabpanel>

            <p-tabpanel value="5">
              <form (submit)="onSubmit()" class="h-full flex flex-col">
                <p-editor
                  (onTextChange)="onAnnotationChange($event)"
                  [formControl]="annotationsControl"
                  class="flex-1 min-h-0">
                  <ng-template #header>
                     <span class="ql-formats">
                      <select class="ql-font">
                        <option selected></option>
                        <option value="serif">Serif</option>
                        <option value="monospace">Monospace</option>
                      </select>
                      <select class="ql-size">
                        <option value="small">Small</option>
                        <option selected></option>
                        <option value="large">Large</option>
                        <option value="huge">Huge</option>
                      </select>
                    </span>
                    <span class="ql-formats">
                        <button type="button" class="ql-bold" aria-label="Bold"></button>
                        <button type="button" class="ql-italic" aria-label="Italic"></button>
                        <button type="button" class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-script" value="sub"></button>
                        <button class="ql-script" value="super"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                    </span>
                    <span class="ql-formats">
                        <select class="ql-align">
                          <option selected></option>
                          <option value="center"></option>
                          <option value="right"></option>
                          <option value="justify"></option>
                        </select>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-blockquote"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-link"></button>
                    </span>
                  </ng-template>
                </p-editor>
                <div class="inline-flex items-center justify-start gap-2 py-2">
                  <p-button
                    rounded
                    outlined
                    size="small"
                    label="Wyczyść"
                    icon="pi pi-trash"
                    (onClick)="onClearAnnotations()">
                  </p-button>
                  <p-button
                    rounded
                    size="small"
                    label="Zapisz"
                    icon="pi pi-save"
                    type="submit"
                    [disabled]="!annotationsChanged()">
                  </p-button>
                </div>
              </form>
            </p-tabpanel>
            <p-tabpanel value="6">
              <div class="h-full min-h-0 overflow-y-auto">
                <div class="px-4 py-2">
                  <p-message [severity]="tabBannerType" [icon]="tabBannerIcon">
                    Zarządzanie dokumentacją fotograficzną pojazdu
                  </p-message>
                </div>
                <div class="p-4 flex flex-col gap-4">
                  <p-fileupload
                    #imagesUpload
                    (onSelect)="onUploadSelect($event)"
                    (onClear)="onUploadClear()"
                    [multiple]="true"
                    accept="image/*"
                    [customUpload]="true"
                    mode="advanced">
                    <ng-template pTemplate="header" let-onChoose="chooseCallback" let-onClear="clearCallback">
                      <div class="w-full inline-flex items-center justify-start gap-2">
                        <p-button
                          label="Wybierz zdjęcia"
                          rounded
                          icon="pi pi-images"
                          size="small"
                          (onClick)="onChoose()">
                        </p-button>
                        <p-button
                          label="Wyczyść"
                          rounded
                          outlined
                          icon="pi pi-trash"
                          severity="danger"
                          size="small"
                          (onClick)="onClear()">
                        </p-button>
                        <p-button
                          label="Wyślij"
                          rounded
                          icon="pi pi-upload"
                          size="small"
                          (onClick)="uploadImages()"
                          [disabled]="selectedUploadImages.length === 0">
                        </p-button>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="empty">
                      <div
                        class="w-full h-[200px] flex flex-col items-center justify-center gap-2 border-2 border-surface-300 border-dashed bg-surface-100 rounded-xl text-surface-500">
                        <i class="pi pi-images text-4xl"></i>
                        <span class="text-lg font-semibold">Przeciągnij i upuść pliki</span>
                      </div>
                    </ng-template>
                  </p-fileupload>

                  @if (orchestrator.vehicleImages$ | async; as images) {
                    @if (images.length > 0) {
                      <div class="pr-1">
                        <div class="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-2">
                          @for (image of images; track image.id) {
                            <div class="rounded-lg overflow-hidden ring-1 ring-surface-200 bg-surface-0">
                              <div class="h-20 bg-surface-100">
                                <img [src]="image.publicUrl" class="size-full object-cover"
                                     [alt]="'Zdjęcie ' + image.imageNumber">
                              </div>
                              <div class="px-2 py-1 inline-flex items-center justify-between w-full">
                                <div class="text-[10px] text-surface-500">
                                  #{{ image.imageNumber }}
                                </div>
                                <p-button
                                  rounded
                                  outlined
                                  severity="danger"
                                  icon="pi pi-trash"
                                  size="small"
                                  (onClick)="deleteImage(image.id)">
                                </p-button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    } @else {
                      <div class="rounded-xl p-6 text-center text-surface-500 bg-surface-50 ring-1 ring-surface-200">
                        Brak zdjęć. Dodaj pierwsze zdjęcia pojazdu powyżej.
                      </div>
                    }
                  }
                </div>
              </div>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  </div>


  <p-speeddial
    mask
    direction="up"
    [model]="actionItems"
    [rotateAnimation]="false"
    [tooltipOptions]="{ tooltipPosition: 'left', tooltipStyleClass: 'text-xs' }"
    [style]="{ position: 'absolute', right: '1.4rem', bottom: '1.4rem' }">
    <ng-template pTemplate="icon">
      <i class="pi pi-wrench text-2xl py-2 px-1"></i>
    </ng-template>
  </p-speeddial>
</app-panel>
